import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30b43e5f")

_pushScopeId("data-v-30b43e5f")
const _hoisted_1 = { class: "password-reset-confirm" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "新しいパスワードを設定", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "hint" }, "半角のアルファベットと数字両方を含む6〜20文字", -1)
const _hoisted_4 = {
  key: 0,
  class: "error"
}
const _hoisted_5 = {
  key: 1,
  class: "error"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "リンクが無効です", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "description" }, "このパスワードリセットリンクは無効または期限切れです。もう一度パスワードリセットをお試しください。", -1)
const _hoisted_8 = {
  key: 0,
  class: "error"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TextField = _resolveComponent("TextField")
  const _component_BaseRoundRectButton = _resolveComponent("BaseRoundRectButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isTokenValid)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createVNode("form", {
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createVNode(_component_TextField, {
              class: "password-field",
              label: "新しいパスワード",
              type: "password",
              modelValue: _ctx.state.newPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.newPassword = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_3,
            _createVNode(_component_TextField, {
              class: "password-field",
              label: "新しいパスワード（確認）",
              type: "password",
              modelValue: _ctx.state.confirmPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.confirmPassword = $event))
            }, null, 8, ["modelValue"]),
            (_ctx.localizationError != null)
              ? (_openBlock(), _createBlock("p", _hoisted_4, _toDisplayString(_ctx.localizationError.message), 1))
              : _createCommentVNode("", true),
            (_ctx.state.validationError)
              ? (_openBlock(), _createBlock("p", _hoisted_5, _toDisplayString(_ctx.state.validationError), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_BaseRoundRectButton, {
              class: "submit-button",
              text: "パスワードを変更",
              onClick: _ctx.handleSubmit,
              isPushed: _ctx.isLoading
            }, null, 8, ["onClick", "isPushed"])
          ], 32)
        ], 64))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _hoisted_6,
          _hoisted_7,
          (_ctx.localizationError != null)
            ? (_openBlock(), _createBlock("p", _hoisted_8, _toDisplayString(_ctx.localizationError.message), 1))
            : _createCommentVNode("", true),
          _createVNode("p", {
            class: "back-link",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToPasswordReset && _ctx.goToPasswordReset(...args)))
          }, "パスワードリセット画面へ")
        ], 64))
  ]))
})